import { render, staticRenderFns } from "./BusinessCreaditApp.vue?vue&type=template&id=22075bc9"
import script from "./BusinessCreaditApp.vue?vue&type=script&lang=js"
export * from "./BusinessCreaditApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports